import { interpret } from '@fingermarkglobal/utilities';
import { createLoyaltyClaimMachine } from './machines/loyalty-claim';

const doLoyaltyClaim = ({ transition = null, token, transactionId, cart, integrationStoreId }) => {
  const machine = createLoyaltyClaimMachine({ token, transactionId, cart, integrationStoreId });

  const { instance: loyaltyClaimMachine } = interpret({
    name: 'loyaltyClaimMachine',
    machine,
    transition,
  });

  return { loyaltyClaimMachine };
};

export { doLoyaltyClaim };
